module.exports = new __parcel__URL__("empty-state-growth-sprout.36bafc1e.svg").toString();